import { variantOptionsStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantOptions";
import { css } from "styled-components";

variantOptionsStyles.wrapper = {
    css: css`
        width: 100%;
        margin-top: 10px;
    `,
};
